import { render } from "./OrderMainInformationCard.vue?vue&type=template&id=574bc52a&scoped=true"
import script from "./OrderMainInformationCard.vue?vue&type=script&lang=js"
export * from "./OrderMainInformationCard.vue?vue&type=script&lang=js"

import "./OrderMainInformationCard.vue?vue&type=style&index=0&id=574bc52a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574bc52a"]])

export default __exports__